import DenominationBaseController from '../common/denomination.base.controller'
import AppConstatnt from '../../../../../config/app.constants';

class DenominationEditController extends DenominationBaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, DenominationService, Modal, $translate, $stateParams, $q, ShiptypeService, CurrencyService, SetupService, $scope) {

        super(Auth, $state, User, DenominationService, Modal, $translate, $stateParams)
        this.CurrencyService = CurrencyService;
        this.ShiptypeService = ShiptypeService;
        this.SetupService = SetupService;
        this.$stateParams = $stateParams;
        this.$q = $q;
        this.$scope = $scope;
        this.hasACL = {};
        this.rawId = '';
        this.shiptypeMismatch = false;

        this.defaultModel = {
            id: '',
            name: '',
            faceValue: '',
            currencyId: null,
            shiptypeId: null,
            icon: '',
            coinFlag: false,
            sortOrder: '',
            strapCount: '',
            bundleCount: '',
            loadDetectThreshold: 0,
            coinPackaging: null,
            multiDenomPackable: false,
            unfit: false,
            individualDenominationId: null,
            selectedFiles:[],
        };
        this.loading = false;
        this.model = angular.copy(this.defaultModel);
        this.branchId = this.User.getUser().branchId;

        this.$scope.$watchGroup([
            () => this.model.shiptypeId,
            () => this.model.coinFlag
        ], () => this.validateShiptypeMatch());
    }

    validateShiptypeMatch() {
        const MISMATCH_MESSAGE = 'Denomination ID and Shiptype ID must be set to the same value';
        this.shiptypeMismatch = !!(this.model.coinFlag && this.model.shiptypeId && this.model.shiptypeId.Value && this.model.shiptypeId.Value !== this.rawId);

        if (this.shiptypeMismatch) {
            this.errorMessage = MISMATCH_MESSAGE;
        } else if (this.errorMessage === MISMATCH_MESSAGE) {
            this.errorMessage = '';
        }
    }

    isMultiDenomPackableAllowed() {
        if (!this.model.coinFlag) {
            return true;
        }
        if (this.model.coinPackaging && ['INDIVIDUAL','ROLLED'].includes(this.model.coinPackaging)) {
            return true;
        }
        return false;
    }

    onCoinPackagingChange() {
        if (!this.isMultiDenomPackableAllowed()) {
            this.model.multiDenomPackable = false;
        }
    }

    onCoinFlagChange() {
        if (!this.model.coinFlag) {
            return;
        }
        if (!this.isMultiDenomPackableAllowed()) {
            this.model.multiDenomPackable = false;
        }
    }

    $onInit() {
        this.model.loading = true;
        this.$q.all([
            this.CurrencyService.all(null, 0, 100),
            this.Service.get(this.$stateParams.id),
            this.SetupService.get(this.branchId)
        ])
            .then((data) => {
                const availableCurrencyIds = data[2].availableCurrencyIds ? data[2].availableCurrencyIds : [];
                this.currencyData = data[0].results.filter(currency => availableCurrencyIds.includes(currency.id));
                this.denominationData = data[1].results;
                this.defaultModel = data[1];
                this.rawId = data[1].id
                this.model.id = data[1].id
                this.model.name = data[1].name
                this.model.faceValue = Math.abs(data[1].faceValue).toFixed(2)
                this.originalFaceValue = Math.abs(data[1].faceValue).toFixed(2)
                this.ledgerUsage = data[1].ledgerUsage || null
                this.model.currencyId = data[1].currencyId
                this.model.shiptypeId = data[1].shiptypeId
                this.model.icon = data[1].icon
                this.model.coinFlag = data[1].coinFlag
                this.model.coinPackaging = data[1].coinPackaging
                this.model.multiDenomPackable = data[1].multiDenomPackable
                this.model.unfit = data[1].unfit
                this.model.sortOrder = data[1].sortOrder
                this.model.strapCount = data[1].strapCount;
                this.model.bundleCount = data[1].bundleCount;
                this.model.loadDetectThreshold = data[1].loadDetectThreshold;
                this.model.isIconExists = data[1].isIconExists;
                // this.model.imageData = data[1].imageData;
                if (!this.isMultiDenomPackableAllowed()) {
                    this.model.multiDenomPackable = false;
                }

                if (data[1].shiptype) {
                    data[1].shiptype.Key = data[1].shiptype.id + " | " + data[1].shiptype.description;
                    data[1].shiptype.Value = data[1].shiptype.id;
                }

                this.model.shiptypeId = data[1].shiptype;
                this.getAllShiptype('', 0);
                if (data[1].individualDenomination) {
                    data[1].individualDenomination.Key = data[1].individualDenomination.id + " | " + data[1].individualDenomination.name;
                    data[1].individualDenomination.Value = data[1].individualDenomination.id;
                }
                this.model.individualDenominationId = data[1].individualDenomination;
                this.getAllDenominations('', 0);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    // load all shiptype
    loadshiptype(searchKey, offset) {

        searchKey = searchKey || '';

        const shiptypeSearchObj = {
            queryJSON: {
                rules: [
                    {
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            },
                            {
                                field: 'description',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }
                            ],
                            operator: 'OR'
                        }
                    }
                ],
                operator: 'AND'
            },
        }

        return shiptypeSearchObj.queryJSON.rules.length ? shiptypeSearchObj : null;
    }

    // get all shiptype
    getAllShiptype(searchKey, offset) {
        const loadShiptypeDatas = this.loadshiptype(searchKey);
        if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
            offset = offset - 1;
        }
        this.ShiptypeService.all(loadShiptypeDatas, offset, AppConstatnt.defaultPageLimit)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.totalRecords = data.total;
                    this.shiptypeList = this.mappingShiptypeData(data.results, searchKey);
                    if (!searchKey && this.model.shiptypeId) {
                        this.shiptypeList.unshift(this.model.shiptypeId);
                    }
                }
                else {
                    const shiptype = this.mappingShiptypeData(data.results, searchKey);
                    this.shiptypeList = this.shiptypeList.concat(shiptype);
                }
            })
    }

    mappingShiptypeData(shiptypes, searchKey) {
        let shiptypeData = [];
        shiptypes.map((shiptype) => {
            if (!searchKey) {
                const currentShiptypeId = (this.model && this.model.shiptypeId) ? this.model.shiptypeId.id : null;
                if (!currentShiptypeId || shiptype.id !== currentShiptypeId) {
                    shiptype.Key = shiptype.id + " | " + shiptype.description;
                    shiptype.Value = shiptype.id;
                    shiptypeData.push(shiptype);
                }
            } else {
                shiptype.Key = shiptype.id + " | " + shiptype.description;
                shiptype.Value = shiptype.id;
                shiptypeData.push(shiptype);
            }
        });
        return shiptypeData;
    }
    
    loadDenomination(searchKey, offset) {

        searchKey = searchKey || '';

        const denominationSearchObj = {
            queryJSON: {
                rules: [
                    {
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            },
                            {
                                field: 'name',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }
                            ],
                            operator: 'OR'
                        }
                    }
                ],
                operator: 'AND'
            },
        }

        return denominationSearchObj.queryJSON.rules.length ? denominationSearchObj : null;
    }

    getAllDenominations(searchKey, offset) {
        const loadDenominationDatas = this.loadDenomination(searchKey);
        if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
            offset = offset - 1;
        }
        this.Service.all(loadDenominationDatas, offset, AppConstatnt.defaultPageLimit)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.totalDenominationRecords = data.total;
                    this.denominationList = this.mappingDenominationData(data.results, searchKey);
                    if (!searchKey && this.model.individualDenominationId) {
                        if (!this.denominationList.find(x => x.Value === this.model.individualDenominationId.Value)) {
                            this.denominationList.unshift(this.model.individualDenominationId);
                        }
                    }
                }
                else {
                    const denomination = this.mappingDenominationData(data.results, searchKey);
                    this.denominationList = this.denominationList.concat(denomination);
                }
            })
    }

    mappingDenominationData(denominations, searchKey) {
        let denomData = [];
        denominations.map((denom) => {
            if (!searchKey) {
                const currentId = (this.model && this.model.individualDenominationId) ? this.model.individualDenominationId.id : null;
                if (!currentId || denom.id !== currentId) {
                    denom.Key = denom.id + " | " + denom.name;
                    denom.Value = denom.id;
                    denomData.push(denom);
                }
            } else {
                denom.Key = denom.id + " | " + denom.name;
                denom.Value = denom.id;
                denomData.push(denom);
            }
        });
        return denomData;
    }

    reset() {
        this.model = angular.copy(this.defaultModel);
		this.model.shiptypeId = this.defaultModel.shiptype;
        this.model.individualDenominationId = this.defaultModel.individualDenomination;
        this.clearErrors();
    }

    isFaceValueChanged() {
        if (this.originalFaceValue === undefined || this.originalFaceValue === null) return false;
        const newFaceValue = Number(this.model.faceValue);
        if (!isFinite(newFaceValue) || this.model.faceValue === '' || this.model.faceValue === null) return false;
        return newFaceValue !== Number(this.originalFaceValue);
    }

    hasLedgerHistory() {
        return !!(this.ledgerUsage && this.ledgerUsage.hasLedgerHistory);
    }

    showFaceValueWarning() {
        return this.isFaceValueChanged() && this.hasLedgerHistory();
    }

    formatNoteCount(count) {
        return (Number(count) || 0).toLocaleString('en-US');
    }

    submit() {
        if (this.showFaceValueWarning()) {
            return this.confirmFaceValueChange();
        }
        return this.saveDenomination();
    }

    confirmFaceValueChange() {
        this.Modal.confirm({
            header: this.$translate.instant('denomination.face_value_change_title'),
            message: this.$translate.instant('denomination.face_value_change_confirm'),
            type: 'warning',
            callback: ({ modal }) => {
                modal.close();
                this.saveDenomination();
            },
            negative: ({ modal }) => {
                modal.close();
            }
        });
    }

    saveDenomination() {
        this.loading = true;
        let denominationIcon = []
        if (this.model.selectedFiles && this.model.selectedFiles.length && this.model.selectedFiles[0].hasOwnProperty('base64Data')) {
            this.model.selectedFiles.forEach((d) => {
                denominationIcon.push({ base64String: d.base64Data, fileName: `${this.rawId}.png`});
            })
        }
        this.Service.update(this.rawId, {
            id: this.rawId,
            name: this.model.name,
            faceValue: this.model.faceValue,
            currencyId: this.model.currencyId,
            shiptypeId: this.model.shiptypeId.Value,
            icon: this.model.icon || null,
            coinFlag: this.model.coinFlag || false,
            sortOrder: this.model.sortOrder,
            strapCount: ( this.model.coinFlag || this.model.strapCount === '' || this.model.strapCount === undefined) ? 0 : Number(this.model.strapCount),
            bundleCount: (this.model.coinFlag || this.model.bundleCount === '' || this.model.bundleCount === undefined) ? 0 : Number(this.model.bundleCount),
            loadDetectThreshold: this.model.loadDetectThreshold || 0,
            coinPackaging: this.model.coinFlag ? this.model.coinPackaging : null,
            multiDenomPackable: this.isMultiDenomPackableAllowed() ? this.model.multiDenomPackable : false,
            unfit: this.model.unfit || false,
            individualDenominationId: (this.model.individualDenominationId && this.model.individualDenominationId.Value && this.model.coinFlag && this.model.coinPackaging !== 'INDIVIDUAL') ? this.model.individualDenominationId.Value : null,
            denominationIcon
        }, this.branchId)
            .then((data) => {
                this.loading = false;
                window.history.go(-1)
            })
            .catch((err) => {
                this.loading = false;
                if (err && err.data && err.data.errors) {
                    err.data.errors.map((e) => {
                        this.errorMessage += e.message + '<br/>'
                    })
                }
                else {
                    this.errorMessage = this.$translate.instant(err.data.message);
                }
            })
    }
    calculateCount(type) {
        if (type === 'strapCount') {
            this.model.strapCount = this.model.bundleCount * 10;
        } else {
            this.model.bundleCount = this.model.strapCount / 10;
        }
    }
}

export default DenominationEditController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/denomination/edit/denomination.edit.controller.js